module.exports = __webpack_public_path__ + "img/calendar-icon.77d0f1d0.svg";